module.exports = __webpack_public_path__ + "img/clippy.1cef6c51.png";